jQuery_T4NT(document).ready(function($) {
    // Initial price setup on page load
    //updatePrices(); // Set initial prices on page load
 setTimeout(updatePrices, 300);
    // Listen for variant change event
    $(document).on("variant:changed", function(evt) {
        // Delay to ensure all data is loaded
        setTimeout(updatePrices, 300);
    });

    // Function to format money
    function formatMoney(value) {
        return new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' }).format(value);
    }

    // Function to update the new price display
    function updatePrices() {
        const originalPriceElement = $('.t4s-product__info-container .t4s-product-price');
        const newPriceElement = $('.t4s-product__info-container .t4s-product--new-price');
        const wholesalepricelement = $('.t4s-product__info-container #total-price');
        const prprice = $('.t4s-product__info-container #pr-price');
       const estimatetax = $('.t4s-product__info-container #estimate-tax');

      
           // Check if the price elements exist
        if (!originalPriceElement.length || !newPriceElement.length) {
            console.warn('Price elements not found.'); // Change to warn for better logging
            newPriceElement.html('<span class="error-message">Price information not available.</span>'); // Display a fallback message
            return; // Exit the function early
        }

        // Fetch the compare price and final price from <del> and <ins>
        const comparePriceElement = originalPriceElement.find('del');
        const finalPriceElement = originalPriceElement.find('ins');

        // Get the original values
        const comparePrice = comparePriceElement.length ? parseFloat(comparePriceElement.text().replace(/[^0-9.-]+/g, "")) : null;
        const finalPrice = finalPriceElement.length ? parseFloat(finalPriceElement.text().replace(/[^0-9.-]+/g, "")) : null;
        const estimateTaxP = estimatetax.length ? parseFloat(estimatetax.text().replace(/[^0-9.-]+/g, "")) : null;
        console.log('Compare Price:', comparePrice);
        console.log('Final Price:', finalPrice);

        let updatedFinalPrice;
        let comparePricee;

        // Check if sale is detected
        if (finalPrice !== null) {
            // Sale detected
            updatedFinalPrice = finalPrice + estimateTaxP; // Add $10 to the final price
            comparePricee = comparePrice + estimateTaxP;
        } else {
            // No sale detected
            const singlePriceText = originalPriceElement.text().replace(/[^0-9.-]+/g, ""); // Remove $ and get value
            const singlePrice = parseFloat(singlePriceText);
            updatedFinalPrice = singlePrice + estimateTaxP; // Add $10
            comparePricee = comparePrice + estimateTaxP;
        }

        // Update the new price element based on the presence of the compare price
        if (comparePrice !== null) {
            newPriceElement.html(`<del>${formatMoney(comparePricee)}</del> <ins>${formatMoney(updatedFinalPrice)}</ins>`);
            wholesalepricelement.html(`<del>${formatMoney(comparePricee)}</del> <ins>${formatMoney(updatedFinalPrice)}</ins>`);
           prprice.html(`<del>${formatMoney(comparePrice)}</del> <ins>${formatMoney(finalPrice)}</ins>`);
           // prprice.html(originalPriceElement.text());
        } else {
            newPriceElement.html(`${formatMoney(updatedFinalPrice)}`);
            wholesalepricelement.html(`${formatMoney(updatedFinalPrice)}`);
            prprice.html(originalPriceElement.text());
        }

        // Prevent duplicates in the new price element
        const uniqueContent = newPriceElement.html().replace(/<del>\s*<\/del>/g, '').trim(); // Remove empty <del>
        newPriceElement.html(uniqueContent); // Set unique content back to new price element
    }
    
});